import createContextStore from '../../../utils/contextStore/createContextStore';
import { dashboardStoreActions } from './dashboardStoreAction';

const initialState = {
  global: {
    data: null,
    error: null,
    loading: null,
  },
};

const handlers = {
  [dashboardStoreActions.GET_GLOBAL_DATA]: (state, action) => {
    if (action?.data) {
      if (JSON.stringify(action?.data) === JSON.stringify(state.global.data)) {
        return state;
      }
      return { ...state, global: { ...state.global, data: action.data } };
    }
    return state;
  },
  [dashboardStoreActions.GET_GLOBAL_DATA_ERROR]: (state, action) => {
    if (action?.error) {
      return { ...state, global: { ...state.global, error: action.error } };
    }
    return state;
  },
  [dashboardStoreActions.GET_GLOBAL_DATA_LOADING]: (state, action) => {
    if (typeof action?.loading === 'boolean') {
      return { ...state, global: { ...state.global, loading: action.loading } };
    }
    return state;
  },
};
export const [DashboardStateStore, DashboardStateProvider] = createContextStore(initialState, handlers);
